import { css } from "@emotion/css";
import { findUISchema } from "@jsonforms/core";
import { ItemProps } from "../types";
import { DeleteButton } from "../DeleteButton";
import { JsonFormsDispatch } from "@jsonforms/react";
import { ExpandableCard } from "@certn/cascadia-react";
import { Stack } from "@certn/cascadia";
import { useItemHeadingText } from "../ItemHeading/utils";
import { useContext, useEffect, useState } from "react";
import { CascadiaJsonFormContext } from "../../../../CascadiaJsonFormContext";
import { ItemSubtitle } from "../ItemSubtitle";
import { ItemEditControls } from "../ItemEditControls";
import { useExpandable } from "../../expandable-context";
import { getHasItemEditToggle } from "../../utils";

export function CardItem(props: ItemProps) {
  const {
    isOpen,
    index,
    minItems,
    label,
    schema,
    uischema,
    uischema: { options = {} },
    uischemas,
    path,
    rootSchema,
  } = props;
  const headingText = useItemHeadingText(
    index,
    label,
    minItems,
    uischema,
    path
  );
  const { isSummaryForPath, isSummary: globalIsSummary } = useContext(
    CascadiaJsonFormContext
  );
  const isSummary = isSummaryForPath?.(props.path);
  const mustBeExpanded =
    (options.lockExpandedWhenEditing ?? false) && !isSummary;
  const [desiredExpandedState, setDesiredExpandedState] = useState(isOpen);
  const { expandable, setExpandable } = useExpandable();
  const itemSchema = findUISchema(
    uischemas || [],
    schema,
    uischema.scope,
    path,
    undefined,
    uischema,
    rootSchema
  );

  useEffect(() => {
    setExpandable(!mustBeExpanded);
    if (mustBeExpanded) {
      setDesiredExpandedState(true);
    }
  }, [mustBeExpanded]);

  useEffect(() => {
    setDesiredExpandedState(isOpen);
  }, [isOpen]);

  const deleteButtonLocation: "top" | "bottom" =
    options.deleteButtonLocation || "top";

  return (
    <ExpandableCard
      title={headingText || ""}
      titleStyle={options.titleStyle}
      subtitle={<ItemSubtitle {...props} />}
      cardStyles={options.cardStyles}
      expanded={desiredExpandedState || mustBeExpanded}
      expandable={expandable}
      titleIcon={options.icon}
    >
      <div className={styles.cardContent}>
        <Stack gap="space-4">
          {(deleteButtonLocation === "top" ||
            getHasItemEditToggle(uischema, globalIsSummary)) && (
            <Stack orientation="horizontal" justify="end" gap="space-2">
              {deleteButtonLocation === "top" && <DeleteButton {...props} />}
              <ItemEditControls {...props} />
            </Stack>
          )}
          <JsonFormsDispatch
            schema={props.schema}
            uischema={itemSchema}
            path={props.path}
          />
          {deleteButtonLocation === "bottom" && (
            <Stack orientation="horizontal" justify="end" gap="space-0">
              <DeleteButton {...props} />
            </Stack>
          )}
        </Stack>
      </div>
    </ExpandableCard>
  );
}

const styles = {
  cardContent: css({
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
  }),
};
